// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { UpdateStatusResultFragment } from './update-status-result.fragment.generated';
export type UpdateStatusAllResponseFragment = { __typename?: 'UpdateStatusAllResponseDTO', results: Array<{ __typename?: 'UpdateStatusResultDTO', eInvoiceStatus: Types.EInvoiceStatusEnumDto | null, invoiceId: number }> };

export const UpdateStatusAllResponseFragment = gql`
    fragment UpdateStatusAllResponse on UpdateStatusAllResponseDTO {
  results {
    ...UpdateStatusResult
  }
}
    ${UpdateStatusResultFragment}`;
/* eslint-enable */